import type { ComponentType } from 'react';
import type { InputProps } from '../fields/types';
import { Text } from '../fields/Text';
import { Textarea } from '../fields/Textarea';
import { Select } from '../fields/Select';
import { Radio } from '../fields/Radio';
import { Checkbox } from '../fields/Checkbox';
import { DateInput } from '../fields/Date';
import { NumberInput } from '../fields/Number';

export const fieldRegistry: Record<string, ComponentType<InputProps>> = {
  text: Text,
  textarea: Textarea,
  select: Select,
  radio: Radio,
  checkbox: Checkbox,
  date: DateInput,
  number: NumberInput,
  email: Text,
  phone: Text,
};
